import { render, staticRenderFns } from "./WhiteLabelBannerComponent.vue?vue&type=template&id=0a3cf75f&scoped=true"
import script from "./WhiteLabelBannerComponent.vue?vue&type=script&lang=js"
export * from "./WhiteLabelBannerComponent.vue?vue&type=script&lang=js"
import style0 from "./WhiteLabelBannerComponent.vue?vue&type=style&index=0&id=0a3cf75f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3cf75f",
  null
  
)

export default component.exports